// App.tsx
// ====================================================================
// ▶ 앱 전역 UI 초기화 및 구성 요소
// - 전역 상태 관리 (Zustand, React Query, Context Provider 등)
// - 라우팅(Router) 및 레이아웃 설정
// - 비동기 초기 데이터 로딩(Remote Config, Auth check)
// ====================================================================

import BRIDGES from 'bridges/registry';
import AnimationScreenRouter from 'routing/AnimationScreenRouter';
import BottomSheetRouter from 'routing/BottomSheetRouter';
import Navigation from 'routing/Navigation';
import ToastRouter from 'routing/ToastRouter';

Object.entries(BRIDGES).forEach(([key, value]) => {
  (window as any)[key] = value;
});

function App() {
  return (
    <>
      <Navigation />
      <BottomSheetRouter />
      <ToastRouter />
      <AnimationScreenRouter />
    </>
  );
}

export default App;
